<template>
  <div
    id="mixtmt_footer"
    v-show="currThemeObj && currThemeObj.cssStyle"
    :style="{
      '--mixtmt_whiteColor': currThemeObj.cssStyle.whiteColor,
      '--mixtmt_footer_bg': `url('/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/footer_bg.png')`,
    }"
  >
    <span class="companyName">
      <span
        v-for="(text, index) in companyName"
        :key="index"
        v-text="text"
      ></span>
    </span>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'mixtmt_footer',
  mixins: [cup_base_data_mixin],
  data() {
    return {
      companyName: [
        '北京晓数聚数字科技有限公司',
        'Copyright MixTMT.All Rights Reserved 2016-2025',
      ],
    }
  },
  mounted() {
    console.debug(this.currThemeObj, this.cssStyle)
  },
}
</script>

<style lang="scss" scoped>
#mixtmt_footer {
  position: relative;
  width: 100%;
  height: 9.722vw;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% auto;
  background-image: var(--mixtmt_footer_bg);
  object-fit: cover;
  .companyName {
    position: absolute;
    top: 50%;
    left: 0;
    z-index: 2;
    transform: translateY(-50%);
    width: 100%;
    padding: 0 20%;
    display: inline-block;
    font-size: 0.972vw;
    text-align: center;
    color: var(--mixtmt_whiteColor);
    letter-spacing: 0.1vw;
    span {
      display: block;
      line-height: 2vw;
    }
  }
}
</style>
